// src/integrations/providers/bigquery/bigQueryFormPortability.js

import {
  sanitizeProviderColumnsInSubmissionSettings,
} from '../../formPortability/providerColumnPortabilityUtils';

const PROVIDER_ID = 'bigquery';

export const bigQueryFormPortabilityPolicy = Object.freeze({
  providerId: PROVIDER_ID,
  duplicatePolicy: 'strip',

  sanitizeSubmissionSettingsForDuplicate(submissionSettings = {}) {
    const result = sanitizeProviderColumnsInSubmissionSettings(
      submissionSettings,
      PROVIDER_ID
    );

    return {
      settings: result.settings,
      diagnostics: {
        changed: result.diagnostics.removedColumnIds.length > 0,
        touchedSettingsKeys: result.diagnostics.touchedSurfaces,
        removedSettingKeys: [],
        removedColumnIds: result.diagnostics.removedColumnIds,
      },
    };
  },
});